import React, { FC, useCallback, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { localized } from '../../../../../../i18n/i18n';
import { FlexColumn } from '../../../../default-components/flex-column';
import { LargeFormSwitch } from '../../../form/large-form-switch';
import { FirmwareSelector } from '../firmware-selector';
import { GeneralUnitConfigRow } from '../general-unit-config-row';

interface Props {
  connectId: string;
}

export const AdminBackupFirmwareSetting: FC<Props> = React.memo(({ connectId }) => {
  const { setValue, getValues } = useFormContext();

  const [selectedFirmwareOption, setSelectedFirmwareOption] = useState<string>(
    getValues('backupFirmwareVersion') ?? '',
  );

  const onFirmwareSelected = useCallback(
    (firmwareVersion: string) => {
      setSelectedFirmwareOption(firmwareVersion);
      setValue('backupFirmwareVersion', firmwareVersion, { shouldValidate: true, shouldDirty: true });
    },
    [setValue],
  );

  return (
    <FlexColumn gap={2}>
      <GeneralUnitConfigRow
        description={localized('AllowBackupFirmware')}
        input={<LargeFormSwitch name="allowBackupFirmware" />}
      />
      <FirmwareSelector
        connectId={connectId}
        selectedFirmware={selectedFirmwareOption}
        onFirmwareSelectCallback={onFirmwareSelected}
        backupFirmwares
        disabled={!getValues('allowBackupFirmware')}
      />
    </FlexColumn>
  );
});
